import store from './state'
import actions from './actions'
export default _.assign(store, {
  namespaced: true,
  actions,
})
